/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'comment': {
    width: 16,
    height: 16,
    viewBox: '0 0 22.5 20.06',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M21.75 8.45V4.64a4 4 0 0 0-4-3.89H4.69A4 4 0 0 0 .75 4.69v13.93a.68.68 0 0 0 .46.64.52.52 0 0 0 .29.06.71.71 0 0 0 .5-.24l3-2.84h12.81a4 4 0 0 0 3.94-3.94m-4.56-5.86H5.27m6.61 4.72H5.34" id="Layer_1-2" data-name="Layer 1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/comment.js